module.exports = "//public.zight.com/packs/media/images/annotate/line-8fe48c7fd20e3758424b7f450fc73de2.svg";